import { render, staticRenderFns } from "./CriterePortefeuille.vue?vue&type=template&id=5f17b3c1"
import script from "./CriterePortefeuille.vue?vue&type=script&lang=js"
export * from "./CriterePortefeuille.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports